"use strict";
/**
 * `rc` (SEARCH_CONTENT) flag bits — Android `SearchFlags` / K0 profile browse.
 * @see API_Reference.md §SEARCH_CONTENT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RC_PROFILE_SITE_BROWSE = exports.RC_PROFILE_POSTS_BROWSE = exports.RC_PROFILE_TOPICS_BROWSE = exports.RC_ASC_SORT = exports.RC_DATE_SORT = exports.RC_NO_HIGHLIGHT = exports.RC_RECURSION = exports.RC_TITLE_RESULTS = exports.RC_SITE_POSTS = exports.RC_FORUM_TITLES = exports.RC_FORUM_POSTS = void 0;
exports.buildProfileSearchFlags = buildProfileSearchFlags;
exports.RC_FORUM_POSTS = 1;
exports.RC_FORUM_TITLES = 2;
exports.RC_SITE_POSTS = 4;
exports.RC_TITLE_RESULTS = 65536;
exports.RC_RECURSION = 131072;
exports.RC_NO_HIGHLIGHT = 262144;
exports.RC_DATE_SORT = 524288;
exports.RC_ASC_SORT = 1048576;
/** Profile → «темы пользователя» (K0: 589826 = DateSort | TitleResults | ForumTitles). */
exports.RC_PROFILE_TOPICS_BROWSE = exports.RC_DATE_SORT | exports.RC_TITLE_RESULTS | exports.RC_FORUM_TITLES;
/** Profile → «посты пользователя» (K0: 524289 = DateSort | ForumPosts). */
exports.RC_PROFILE_POSTS_BROWSE = exports.RC_DATE_SORT | exports.RC_FORUM_POSTS;
/** Profile → «статьи пользователя» (`rc` SitePosts + DateSort). */
exports.RC_PROFILE_SITE_BROWSE = exports.RC_DATE_SORT | exports.RC_SITE_POSTS;
function buildProfileSearchFlags(profileIn, sort = 'date_desc') {
    let flags = 0;
    if (profileIn === 'posts') {
        flags |= exports.RC_FORUM_POSTS;
    }
    else if (profileIn === 'topics') {
        flags |= exports.RC_FORUM_TITLES | exports.RC_TITLE_RESULTS;
    }
    else {
        flags |= exports.RC_SITE_POSTS;
    }
    if (sort === 'date_desc') {
        flags |= exports.RC_DATE_SORT;
    }
    else if (sort === 'date_asc') {
        flags |= exports.RC_DATE_SORT | exports.RC_ASC_SORT;
    }
    return flags;
}
